import { memo } from 'react';
const SvgWifi = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    className="wifi_svg__feather wifi_svg__feather-wifi"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 12.55a11 11 0 0 1 14.08 0M1.42 9a16 16 0 0 1 21.16 0M8.53 16.11a6 6 0 0 1 6.95 0M12 20h.01" />
  </svg>
);
const Memo = memo(SvgWifi);
export default Memo;
